import type { ControlPanelProps } from './types'

import { useState } from 'react'

import Text, { TextVariant } from '@/components/atomic/text'
import Toggle from '@/components/atomic/toggle'

import { ControlPanelContainer, FilterContainer } from './styles'

export const useControlPanel = (
  initialFilterNonActionable: boolean,
): ControlPanelProps => {
  const [filterNonActionable, setFilterNonActionable] = useState(
    initialFilterNonActionable,
  )

  return {
    filterNonActionable,
    onFilterNonActionableChange: setFilterNonActionable,
  }
}

export function ControlPanel({
  filterNonActionable,
  onFilterNonActionableChange,
}: ControlPanelProps) {
  return (
    <ControlPanelContainer>
      <FilterContainer>
        <Text variant={TextVariant.BodySubtext}>Hide non-actionable (N/A)</Text>
        <Toggle
          checked={filterNonActionable}
          defaultChecked={filterNonActionable}
          onChange={(v) => onFilterNonActionableChange(v)}
        />
      </FilterContainer>
    </ControlPanelContainer>
  )
}
